import { gql } from '@apollo/client';

export const INVESTMENT_PROFILE_QUERY = gql`
  query InvestmentProfileQuery {
    kycIdentity {
      personalInformation {
        netWorth
        netWorthValue
        annualIncome
        annualIncomeValue
        isAccredited
        howWillYouFund
        adventurousType
      }
    }
  }
`;
